import { ValueWrapper } from 'src/components/data-entry-ui/ValueWrapper';

export const createObjectField = <T extends Record<string, unknown>>(
  inputFields: ValueWrapper<any>[],
  title: string,
  fieldName?: string,
) => {
  const fields = inputFields.reduce((acc, curr) => {
    return Object.assign(acc, curr);
  }, {} as { [K in keyof T]: ValueWrapper<T[K]> });

  return fieldName !== undefined
    ? {
        [fieldName]: {
          fields,
          title,
        },
      }
    : {
        fields,
        title,
      };
};
